module.exports = __webpack_public_path__ + "img/img_weixin@2x.d834494a.png";